import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { navLinks, siteConfig } from '@/mocks/site-config';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link to="/" className="flex flex-col items-start whitespace-nowrap cursor-pointer">
            <span className={`font-heading text-xl md:text-2xl font-black tracking-wide transition-colors duration-300 ${
              isScrolled || !isHome ? 'text-primary-500' : 'text-background-50'
            }`}>
              {siteConfig.name}
            </span>
            <span className={`text-[10px] md:text-xs transition-colors duration-300 ${
              isScrolled || !isHome ? 'text-foreground-500' : 'text-background-50/70'
            }`}>
              {siteConfig.subtitle}
            </span>
          </Link>

          <ul className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.href;
              return (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className={`relative px-3 py-2 text-sm font-medium whitespace-nowrap rounded-lg transition-all duration-200 cursor-pointer ${
                      isActive
                        ? isScrolled || !isHome
                          ? 'text-primary-500'
                          : 'text-background-50'
                        : isScrolled || !isHome
                          ? 'text-foreground-700 hover:text-primary-500 hover:bg-primary-50'
                          : 'text-background-50/80 hover:text-background-50 hover:bg-white/10'
                    }`}
                  >
                    {link.label}
                    {isActive && (
                      <span className="absolute bottom-1 left-1/2 -translate-x-1/2 w-4 h-0.5 bg-primary-500 rounded-full" />
                    )}
                  </Link>
                </li>
              );
            })}
          </ul>

          <button
            onClick={() => setIsMobileOpen(!isMobileOpen)}
            className={`md:hidden w-9 h-9 flex items-center justify-center rounded-lg cursor-pointer transition-colors ${
              isScrolled || !isHome ? 'text-foreground-800 hover:bg-background-100' : 'text-background-50 hover:bg-white/10'
            }`}
          >
            <i className={`text-xl ${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'}`} />
          </button>
        </div>
      </div>

      {isMobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.href;
              return (
                <Link
                  key={link.href}
                  to={link.href}
                  onClick={() => setIsMobileOpen(false)}
                  className={`px-3 py-3 text-sm font-medium rounded-lg transition-colors cursor-pointer whitespace-nowrap ${
                    isActive
                      ? 'text-primary-500 bg-primary-50'
                      : 'text-foreground-700 hover:bg-background-100'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
          </div>
        </div>
      )}
    </nav>
  );
}